<template>
    <div class="invitations-screen">
        <div class="inv-topbar">
            <back-button />
        </div>

        <div class="inv-content">
            <div v-if="hasInvitations" class="inv-hint">
                <v-icon size="16" color="accent">mdi-information-outline</v-icon>
                <span>{{ $t('student.invitations_subtitle') }}.</span>
            </div>

            <skeleton-loader v-if="!showInvitations" type="rows" :count="3" />

            <template v-else-if="invitationsLoaded">
                <div v-if="!hasInvitations" class="inv-empty">{{ $t('coach.no_invitations') }}</div>

                <div v-else class="inv-list">
                    <student-invitation-card v-for="invitation in studentInvitations" :key="invitation.id"
                        :invitation="invitation" @accept="onInvitationAccept" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>

import StudentInvitationCard from "@/components/common/cards/StudentInvitationCard";
import {mapState, mapActions} from 'vuex'
import BackButton from "@/components/common/BackButton";
import SkeletonLoader from '@/components/common/SkeletonLoader'

export default {
    components: {
        BackButton,
        StudentInvitationCard,
        SkeletonLoader,
    },
    data() {
        return {
            showInvitations: false,
            invitationsLoaded: false,
        }
    },
    computed: {
        ...mapState(['studentInvitations']),
        hasInvitations(vm = this) {
            return vm.studentInvitations.length > 0
        },
    },
    methods: {
        ...mapActions(['bindStudentInvitations']),
        onInvitationAccept() {
            const vm = this
            vm.goHome()
        },
        setInvitationsLoaded() {
            const vm = this
            vm.invitationsLoaded = true
            setTimeout(function () {
                vm.showInvitations = true
            }, 500)
        }
    },
    async mounted() {
        const vm = this
        if (!vm.currentUser) return vm.setInvitationsLoaded()
        if (vm.studentInvitations.length === 0) await vm.bindStudentInvitations(vm.currentUser.email)
        vm.setInvitationsLoaded()
    },
}
</script>

<style scoped>

.invitations-screen {
    max-width: 640px;
    margin: 0 auto;
}

.inv-topbar {
    margin-bottom: 12px;
}

.inv-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.inv-hint {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    border-radius: 12px;
    border: 1px solid rgba(51, 153, 153, 0.3);
    background: rgba(51, 153, 153, 0.08);
    font-size: 12px;
    line-height: 1.45;
    color: var(--v-txtSecondary-base);
}

.inv-empty {
    padding: 32px 0;
    text-align: center;
    font-size: var(--fs-body);
    color: var(--v-txtMuted-base);
}

.inv-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

</style>
